/** @file Firestore references + converters. */
import { collection, doc } from "firebase/firestore";
import { getDb } from "./firebase.js";
import { playConverter, teamConverter, userConverter, shareConverter } from "./converters.js";

/** @returns {import("firebase/firestore").Firestore} */
function db() {
  const d = getDb();
  if (!d) {
    throw new Error("Firestore not initialized");
  }
  return d;
}

/**
 * @param {string} uid
 */
export function userDoc(uid) {
  return doc(db(), "users", uid).withConverter(userConverter());
}

/**
 * @param {string} uid
 */
export function playsCol(uid) {
  return collection(db(), "users", uid, "plays").withConverter(playConverter());
}

/**
 * @param {string} uid
 * @param {string} playId
 */
export function playDoc(uid, playId) {
  return doc(db(), "users", uid, "plays", playId).withConverter(playConverter());
}

/**
 * @param {string} uid
 */
export function teamsCol(uid) {
  return collection(db(), "users", uid, "teams").withConverter(teamConverter());
}

/**
 * @param {string} uid
 * @param {string} teamId
 */
export function teamDoc(uid, teamId) {
  return doc(db(), "users", uid, "teams", teamId).withConverter(teamConverter());
}

/** Top-level `shares` collection — viewer reads this unauthenticated. */
export function sharesCol() {
  return collection(db(), "shares").withConverter(shareConverter());
}

/**
 * @param {string} shareId
 */
export function shareDoc(shareId) {
  return doc(db(), "shares", shareId).withConverter(shareConverter());
}
